import React, { useEffect, useState } from "react";
import TimelineService from "../../services/KangarooServices/TimelineService";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Button, Col, Row, Card, CardBody, Badge, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../Components/Common/DeleteModal";
import toast from "react-hot-toast";

const Timeline = () => {
  const [data, setData] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const result = await TimelineService.getdata();
      console.log(result);
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await TimelineService.delete(selectedDeleteItem.id);
        await fetchData();
        toast.success("Timeline deleted successfully");
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to delete Timeline"
        );
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  const handleEdit = (id) => {
    navigate(`/timeline/edit/${id}`);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Timeline" pageTitle="Organizational Timeline" />

        <Row className="mb-4">
          <Col className="col-sm-auto">
            <button
              className="btn btn-success"
              color="primary"
              onClick={() => navigate("/timeline/create")}
            >
              <i className="ri-add-line align-bottom me-1"></i>
              Add Timeline
            </button>
          </Col>
        </Row>

        <Row>
          <Col>
            {data.length === 0 ? (
              <Card className="shadow-sm">
                <CardBody className="text-center py-5">
                  <p className="text-muted mb-3">No timeline events found.</p>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => navigate("/timeline/create")}
                  >
                    + Create Your First Event
                  </Button>
                </CardBody>
              </Card>
            ) : (
              <div className="timeline">
                {data.map((item, index) => (
                  <div
                    key={item.id}
                    className={`timeline-item ${
                      index % 2 === 0 ? "left" : "right"
                    }`}
                  >
                    {/* Icon */}
                    <i className="icon ri-calendar-event-line"></i>

                    {/* Date */}
                    <div className="date">{item.year}</div>

                    {/* Content */}
                    <div className="content">
                      <h6
                        className="text-primary mb-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(`/timeline/details/${item.id}`)}
                      >
                        {item.title}
                      </h6>

                      <div
                        className="text-muted mb-3 fs-6"
                        style={{
    maxHeight: "6em",      // limits height (adjust as needed)
    overflow: "hidden",    // hides content that exceeds maxHeight
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 3,    // limits to 3 lines
    WebkitBoxOrient: "vertical",
  }}
  
                        dangerouslySetInnerHTML={{ __html: item.description }}
                        title={item.description.replace(/<[^>]+>/g, "")}
                      />

                      {/* Actions */}
                      <div className="hstack gap-2">
                        <Button
                          size="sm"
                          color="outline-primary"
                          onClick={() => handleEdit(item.id)}
                        >
                          <i className="ri-edit-line me-1"></i> Edit
                        </Button>

                        <Button
                          size="sm"
                          color="outline-danger"
                          onClick={() => handleDeleteClick(item)}
                        >
                          <i className="ri-delete-bin-line me-1"></i> Delete
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Col>
        </Row>
      </Container>
      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </div>
  );
};

export default Timeline;
